import request from './interceptor'
// import { mockOverviewStats, mockRankingsStats } from '../utils/simulation'
// 统计 API - 全部为 GET 请求

// 每日统计
export function getDailyDeliveryCount(params = {}) {
  return request({ url: '/v1/statistics/daily/delivery-count', method: 'get', params })
}

export function getDailyDeliveryUserCount(params = {}) {
  return request({ url: '/v1/statistics/daily/delivery-user-count', method: 'get', params })
}

export function getDailyDeliveryWeight(params = {}) {
  return request({ url: '/v1/statistics/daily/delivery-weight', method: 'get', params })
}

// 每月统计
export function getMonthlyDeliveryCount(params = {}) {
  return request({ url: '/v1/statistics/monthly/delivery-count', method: 'get', params })
}

export function getMonthlyDeliveryUserCount(params = {}) {
  return request({ url: '/v1/statistics/monthly/delivery-user-count', method: 'get', params })
}

export function getMonthlyDeliveryWeight(params = {}) {
  return request({ url: '/v1/statistics/monthly/delivery-weight', method: 'get', params })
}

// 每年统计
export function getYearlyDeliveryCount(params = {}) {
  return request({ url: '/v1/statistics/yearly/delivery-count', method: 'get', params })
}

export function getYearlyDeliveryUserCount(params = {}) {
  return request({ url: '/v1/statistics/yearly/delivery-user-count', method: 'get', params })
}

export function getYearlyDeliveryWeight(params = {}) {
  return request({ url: '/v1/statistics/yearly/delivery-weight', method: 'get', params })
}

// 分布与排名统计
export function getDistribution(params = {}) {
  return request({ url: '/v1/statistics/distribution', method: 'get', params })
}

export function getRanking(params = {}) {
  return request({ url: '/v1/statistics/ranking', method: 'get', params })
}

// 清运统计（新增）
export function getDailyCleaning(params = {}) {
  return request({ url: '/v1/statistics/daily/cleaning', method: 'get', params })
}

export function getMonthlyCleaning(params = {}) {
  return request({ url: '/v1/statistics/monthly/cleaning', method: 'get', params })
}

export function getYearlyCleaning(params = {}) {
  return request({ url: '/v1/statistics/yearly/cleaning', method: 'get', params })
}

export function getCleaningStatistics(params = {}) {
  return request({ url: 'https://phptj.zhiwahuishou.com/api/stats/cleaning', method: 'get', params })
}

// 青云员统计
export function getCleanerStatistics(params = {}) {
  return request({ url: 'https://phptj.zhiwahuishou.com/api/stats/cleaner', method: 'get', params })
}

// 基础统计（新增）
export function getDeliveryStatistics(params = {}) {
  return request({ url: '/v1/statistics/deliveries', method: 'get', params })
}

export function getUserStatistics(params = {}) {
  return request({ url: '/v1/statistics/users', method: 'get', params })
}

export function getDeviceStatistics(params = {}) {
  return request({ url: '/v1/statistics/devices', method: 'get', params })
}

export function getCompanySummary(params = {}) {
  return request({ url: '/v1/statistics/real-time-overview', method: 'get', params })
}

export function getDevicesStats(params = {}) {
  return request({ url: '/v1/statistics/device-overview', method: 'get', params })
}

export function getOverviewStats(params = {}) {
  return request({ url: 'https://phptj.zhiwahuishou.com/api/stats/overview', method: 'get', params })
  // return mockOverviewStats(params)
}

export function getRankingsStats(params = {}) {
  return request({ url: 'https://phptj.zhiwahuishou.com/api/stats/rankings', method: 'get', params })
  // return mockRankingsStats(params)
}

export function getDeviceMetrics(params = {}) {
  return request({ url: 'https://phptj.zhiwahuishou.com/api/stats/device_metrics', method: 'get', params })
}
